import type { ReactElement } from 'react';

/**
 * Zahlenreihe für Beteiligung und Ergebnis (§15, §18.1).
 *
 * Bewusst als Kacheln und **nicht** als zweispaltige Definitionsliste: Beschriftung und Zahl
 * gehören sichtbar zusammen. Ein `dl` mit drei Rasterspalten trennt die Paare über den
 * Zeilenumbruch hinweg — dann steht die Zahl der einen Angabe neben der Beschriftung der nächsten.
 *
 * Als `dl` bleibt die Auszeichnung gleichwohl richtig: `dt` und `dd` stehen unmittelbar
 * beieinander, das Raster liegt eine Ebene darüber.
 */

export interface Kennzahl {
  beschriftung: string;
  wert: number | undefined;
}

export function Kennzahlen({
  zahlen,
  gross = false,
}: {
  zahlen: Kennzahl[];
  /** Große Darstellung für die Live-Beteiligung im Durchführungsbetrieb. */
  gross?: boolean;
}): ReactElement {
  return (
    <dl className="grid grid-cols-1 gap-3 sm:grid-cols-3">
      {zahlen.map((zahl) => (
        <div
          key={zahl.beschriftung}
          className={['flex flex-col gap-0.5', gross ? 'text-center' : ''].join(' ')}
        >
          <dt className="text-text-gedaempft text-xs">{zahl.beschriftung}</dt>
          <dd
            className={gross ? 'text-2xl font-semibold tabular-nums' : 'font-medium tabular-nums'}
          >
            {zahl.wert ?? '—'}
          </dd>
        </div>
      ))}
    </dl>
  );
}
